import styled from 'styled-components';
import { Image, Box, spacing } from '@landr/maestro';

const PackIcon = styled(Image)`
    width: ${spacing('xxl')};
    height: ${spacing('xxl')};
    border-radius: 2px;
`;

const IconBackground = styled(Box)`
    width: ${spacing('xxl')};
    height: ${spacing('xxl')};
    border-radius: 2px;
    background-color: ${({ theme }): string => theme.palette.neutral[800]};
`;

export const Styled = {
    PackIcon,
    IconBackground,
};
